import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["icon", "ariaLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useToken } from '@hub/design-system-base';
import { IconButton } from '@hub/button';
import Color from 'color';
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowButton = _ref => {
  let {
      icon,
      ariaLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const buttonBackgroundColor = Color(useToken('colors', 'licorice')).alpha(0.5) // eslint-disable-line no-magic-numbers
  .rgb().string();
  return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    icon: icon,
    "aria-label": ariaLabel,
    sx: {
      color: 'white',
      minWidth: 0,
      height: 'auto',
      padding: 'spacing-sm',
      background: buttonBackgroundColor,
      borderRadius: 'full',
      '&:hover': {
        backgroundColor: buttonBackgroundColor,
        '& > svg': {
          opacity: 0.8
        },
        color: 'ghost'
      }
    }
  }, props), {}, {
    "data-id": "feature_arrowButton_ArrowButton_IconButton"
  }));
};